
import { Component, Vue, Prop, Mixins, Watch } from "vue-property-decorator";
import { Doughnut, mixins } from "vue-chartjs";

@Component
export default class DoughnutChart extends Mixins(Doughnut, mixins.reactiveProp) {
  @Prop()
  private options;

  @Watch("chartData.datasets.0.data", { immediate: false, deep: false })
  onPersonChanged1(val: any, oldVal: any) {
    this.$data._chart.update();
    this.$emit("generateLegend", this.$data._chart.generateLegend());
  }

  private mounted() {
    this.renderChart(this.chartData, this.options);
    this.$emit("generateLegend", this.$data._chart.generateLegend());
  }
}
